import {
  Box,
  TableCell,
  TableHead,
  TableRow,
  Table as TableUI,
  Typography,
} from '@astro-ui/components'
import { shallowEqual, useAppSelector } from 'store'
import { dateFormat } from 'utils/helpers/date'

const Table = () => {
  const data = useAppSelector((state) => state.outboundSODetail.data, shallowEqual)

  return (
    <Box>
      <TableUI
        tableContainerProps={{
          sx: { borderRadius: 0, boxShadow: 'unset', borderTop: '1px solid #E9E9E9' },
        }}
        tableHeaders={[]}
        TableHeaderComponent={
          <TableHead>
            <TableRow sx={{ backgroundColor: '#FAFAFA' }}>
              <TableCell textAlign="center">
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  No
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  Nama Aktivitas
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  Tanggal Mulai
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  Tanggal Selesai
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  Durasi
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant="body-smallStrong" whiteSpace="nowrap">
                  Oleh
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
        }
      >
        {data?.supplyOrderActivities?.map((item, index) => (
          <TableRow key={item.activityName}>
            <TableCell textAlign="center">{index + 1}</TableCell>
            <TableCell>
              <Typography>{item.activityName}</Typography>
            </TableCell>
            <TableCell>
              <Typography>
                {item.startDate
                  ? dateFormat({
                      date: new Date(item.startDate),
                      format: 'DD MMM YYYY - HH:mm:ss',
                    })
                  : '-'}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography>
                {item.endDate
                  ? dateFormat({
                      date: new Date(item.endDate),
                      format: 'DD MMM YYYY - HH:mm:ss',
                    })
                  : '-'}
              </Typography>
            </TableCell>
            <TableCell>
              <Typography>{item.duration || '-'}</Typography>
            </TableCell>
            <TableCell>
              <Typography>{item.user}</Typography>
            </TableCell>
          </TableRow>
        ))}
      </TableUI>
    </Box>
  )
}

export default Table
